import React from 'react'

import { FaPhone } from 'react-icons/fa'

function Call() {
    return (
        <div className="background notdesktop">
        <div className="call-container" id="cislo">
        <div className="call-title-container"><h2 className="call-title">Zavoláme Vám!</h2>
        
            <FaPhone className="FaPhone" /></div>
           <form className="call-input-container" action="getmail.php" method="post">
                <div className="call-inputt"><input className="call-input" type="number" name="tel" placeholder="Vaše tel. číslo"></input></div>
                <div className="call-btnn"><button className="call-btn" name="submit" type="submit">Odeslat</button></div>
            </form>            
            <p className="call-contact">Dušan Baťka — 777 338 077</p>
        </div>
        </div>    
    );
  }

export default Call


// WEBPACK FOOTER //
// ./src/components/Call.js